import ReportsParticipants from "./Participants";

export default ReportsParticipants;
